import React from 'react';
import { TeamOutlined, UnorderedListOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { Empty, Typography, Tabs } from 'antd';
import CandidateReferralSection from './CandidateReferralSection';
import CandidateActivityTimeline from './CandidateActivityTimeline';
import SectionHeader from '../common/SectionHeader';

const { Text } = Typography;

const CandidateActivitySection = ({ referrals }) => {
  const tabItems = [
    {
      key: 'applications',
      label: (
        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <UnorderedListOutlined />
          Applications
        </span>
      ),
      children: (
        <div>
          {referrals && referrals.length > 0 ? (
            referrals.map((referral) => (
              <CandidateReferralSection
                key={referral.id}
                referral={referral}
              />
            ))
          ) : (
            <Empty
              description="No referrals found for this candidate"
              style={{ margin: '40px 0' }}
            />
          )}
        </div>
      ),
    },
    {
      key: 'timeline',
      label: (
        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <ClockCircleOutlined />
          Activity Timeline
        </span>
      ),
      children: <CandidateActivityTimeline referrals={referrals} />,
    },
  ];

  return (
    <div style={{ marginBottom: '24px' }}>
      <SectionHeader
        icon={<TeamOutlined />}
        title="Activity"
        description="View applications and referrals"
        iconColor="#1890ff"
        iconBgColor="#e6f7ff"
      />

      <Tabs
        defaultActiveKey="applications"
        items={tabItems}
        style={{ marginTop: '16px' }}
      />
    </div>
  );
};

export default CandidateActivitySection;